import { render } from "./App.vue?vue&type=template&id=92a09876"
import script from "./App.vue?vue&type=script&lang=js"
export * from "./App.vue?vue&type=script&lang=js"

import exportComponent from "C:\\Users\\guill\\Desktop\\MONNOPZ PROYECTOS PERSONALES\\monnopz-portfolio\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__